var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_708)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9988 4.78092C34.9988 7.42118 32.8582 9.56117 30.2171 9.56117C27.5761 9.56117 25.4351 7.42118 25.4351 4.78092C25.4351 2.14067 27.5757 0.000244141 30.2171 0.000244141C32.8586 0.000244141 34.9988 2.14067 34.9988 4.78092Z",
    fill: "#FF0094"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85473 19.7349C9.85473 22.3752 7.71411 24.5156 5.07266 24.5156C2.4312 24.5156 0.291016 22.3752 0.291016 19.7349C0.291016 17.0947 2.43207 14.9542 5.07266 14.9542C7.71325 14.9542 9.85473 17.0947 9.85473 19.7349Z",
    fill: "#F6CD01"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8537 25.816C34.8174 27.5274 38.6063 26.5125 40.3169 23.5491C42.0273 20.5853 41.0117 16.7959 38.0484 15.0843C36.6141 14.2557 34.9865 14.0661 33.4948 14.4269L33.5005 14.4256C27.4101 13.8925 23.7821 11.5409 21.839 7.63229C21.8409 7.63817 21.2378 5.37548 19.0163 4.0925C16.053 2.38086 12.2637 3.39603 10.5534 6.35978C8.84301 9.32352 9.85859 13.1129 12.8219 14.8246C15.0433 16.1076 17.3009 15.4996 17.2977 15.5C22.6007 15.8713 26.5867 18.0173 29.01 22.2061L29.0081 22.2002C29.4417 23.6729 30.4199 24.9882 31.854 25.8164",
    fill: "#FF0094"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6829 35.2199C36.6829 37.8601 34.5419 40.0001 31.9013 40.0001C29.2607 40.0001 27.1196 37.8597 27.1196 35.2199C27.1196 32.5801 29.2603 30.4392 31.9013 30.4392C34.5423 30.4392 36.6829 32.5792 36.6829 35.2199Z",
    fill: "#4538CA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72039 31.5351C9.72011 34.9575 12.4935 37.7313 15.9151 37.7311C19.337 37.7304 22.1108 34.9562 22.1115 31.534C22.1119 29.8776 21.4623 28.3733 20.404 27.2617L20.408 27.266C17.8244 21.725 18.047 17.4072 20.4603 13.7701C20.4562 13.7746 22.1141 12.121 22.1145 9.55563C22.1151 6.13346 19.3413 3.3594 15.9195 3.36004C12.4977 3.36067 9.72381 6.13491 9.72316 9.55709C9.72281 12.1224 11.3781 13.7736 11.3761 13.771C13.7061 18.5493 13.8406 23.0743 11.4248 27.2674L11.4289 27.2628C10.3703 28.3746 9.72037 29.8794 9.72017 31.5355",
    fill: "#F6CD01"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8193 26.076C9.85531 27.787 8.83983 31.5758 10.5509 34.5389C12.2623 37.502 16.0518 38.5172 19.0158 36.8067C20.4505 35.9788 21.4284 34.6641 21.8619 33.1918L21.8601 33.1974C25.367 28.1894 29.2175 26.2232 33.574 26.4947C33.5679 26.4934 35.829 27.1024 38.0508 25.8201C41.0148 24.1095 42.0303 20.3203 40.3188 17.3572C38.6073 14.3941 34.8179 13.3789 31.8539 15.0894C29.6321 16.3718 29.0298 18.6309 29.0311 18.6279C26.058 23.0349 22.2065 25.4139 17.3673 25.4182L17.3734 25.4195C15.8813 25.0587 14.2531 25.2482 12.8188 26.076",
    fill: "#4538CA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.053 26.5824C33.2989 26.4721 32.5526 26.22 31.8524 25.8156L31.8526 25.816C30.4202 24.9888 29.4427 23.6756 29.0083 22.2051C29.0085 22.2053 29.0086 22.2055 29.0087 22.2057L29.0068 22.1998C29.0073 22.2016 29.0078 22.2034 29.0083 22.2051C28.6219 21.5373 28.1958 20.9214 27.731 20.3563C28.1813 19.8204 28.6142 19.2438 29.0299 18.6277C29.0286 18.6307 29.6309 16.3715 31.8527 15.0892C34.8166 13.3787 38.6061 14.3938 40.3176 17.357C40.3838 17.4716 40.4459 17.5875 40.504 17.7044C41.3887 19.4983 41.3902 21.6865 40.3155 23.5487C39.5669 24.8456 38.4203 25.7693 37.1189 26.2546C35.8525 26.7184 34.6813 26.6658 34.053 26.5824Z",
    fill: "#FF0094"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8596,
    height: 40,
    fill: "white",
    transform: "translate(0.291016 0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoText);
export default __webpack_public_path__ + "static/media/logo_no_text.167b8ba15cc32b3829dfb9e4f66fbe32.svg";
export { ForwardRef as ReactComponent };